module.exports = __webpack_public_path__ + "static/media/salad.c1628764.jpg";